<template>
  <div>
    <p class="mt-3"><b>Previous dBm</b></p>
    <div class="mb-2 overview_items-wrapper">
      <div
        class="my-1 d-inline-block dark-modeon text-sm text-center"
        style="border-radius: 0px !important; padding-left: 0px !important"
      >
        <div class="py-1" style="background: rgb(2, 0, 36); color: white">
          dBm
        </div>
        <div class="py-3">
          <h4>
            <b>{{
              singleUserDbData.previousdb?.description?.substring(0, 20) ?? "N/A"
            }}</b>
          </h4>
        </div>
      </div>
      <div
        class="my-1 d-inline-block dark-modeon text-sm text-center"
        style="border-radius: 0px !important; padding-left: 0px !important"
      >
        <div class="py-1" style="background: rgb(2, 0, 36); color: white">
          PPPOE ID
        </div>
        <div class="py-3">
          <h4>
            <b>{{
              singleUserDbData.previousdb?.PPPOE_ID?.substring(0, 20) ?? "N/A"
            }}</b>
          </h4>
        </div>
      </div>
      <div
        class="my-1 d-inline-block dark-modeon text-sm text-center"
        style="border-radius: 0px !important; padding-left: 0px !important"
      >
        <div class="py-1" style="background: rgb(2, 0, 36); color: white">
          Vlan ID
        </div>
        <div class="py-3">
          <h4>
            <b>{{
              singleUserDbData.previousdb?.vlan_id?.substring(0, 20) ?? "N/A"
            }}</b>
          </h4>
        </div>
      </div>
      <div
        class="my-1 d-inline-block dark-modeon text-sm text-center"
        style="border-radius: 0px !important; padding-left: 0px !important"
      >
        <div class="py-1" style="background: rgb(2, 0, 36); color: white">
          Mac Address
        </div>
        <div class="py-3">
          <h4>
            <b>{{
              singleUserDbData.previousdb?.mac_address?.substring(0, 20) ??
              "N/A"
            }}</b>
          </h4>
        </div>
      </div>
      <div
        class="my-1 d-inline-block dark-modeon text-sm text-center"
        style="border-radius: 0px !important; padding-left: 0px !important"
      >
        <div class="py-1" style="background: rgb(2, 0, 36); color: white">
          Port Number
        </div>
        <div class="py-3">
          <h4>
            <b>{{
              singleUserDbData.previousdb?.port_number?.substring(0, 20) ??
              "N/A"
            }}</b>
          </h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PreviousDbmCards",
  props: {
    singleUserDbData: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

